import React from 'react';

import { list as listOrders } from '../../apis/orders';
import { useDocumentTitle } from '../../hooks/useDocumentTitle';
import { usePagination } from '../../hooks/usePagination';
import { useApiQuery } from '../../hooks/useApiQuery';

import { UserOrdersBreadcrumb } from '../../components/users/UserOrdersBreadcrumb';
import { UserSidebarMenu } from '../../components/users/UserSidebarMenu';
import { UserOrdersList } from '../../components/users/UserOrdersList';

export const UserOrdersPage = () => {
    useDocumentTitle('Orders');

    const { pagination, handlers } = usePagination({ page: 1, size: 5 });
    const orders = useApiQuery(listOrders, pagination);

    return (
        <div className="user-orders-page mb-5">
            <h1 className="h3">Orders</h1>
            <UserOrdersBreadcrumb />
            <div className="row">
                <div className="col-sm-4 col-md-4 col-lg-3 mb-3">
                    <UserSidebarMenu />
                </div>
                <div className="col-sm-8 col-md-8 col-lg-9 mb-3">
                    <UserOrdersList {...{ ...orders, handlers }} />
                </div>
            </div>
        </div>
    );
};
